import { useNavigate } from 'react-router-dom'
import NavHeader from '../components/NavHeader'
import Footer from '../components/Footer'

export default function FeaturesPage() {
  const navigate = useNavigate()

  const features = [
    {
      title: 'Real-Time HMRC & Companies House Integration',
      description:
        'BritFiler connects directly to HMRC and Companies House through secure, approved APIs. You can submit Self-Assessment returns, CT600 forms, company accounts, and confirmation statements without leaving the platform. Every submission receives instant acknowledgment, ensuring fast processing and guaranteed compliance with the latest regulations.',
    },
    {
      title: 'Guided Filing Wizards',
      description:
        'Designed for non-accountants, our filing wizards lead you through each section step-by-step using simple language. Calculations are automated where possible, and the system shows you exactly what information is needed. Before submitting, you can review everything in a clean summary to ensure accuracy and confidence.',
    },
    {
      title: 'Intelligent Checks & Compliance Engine',
      description:
        "BritFiler's smart validation system analyses your entries in real time, identifying missing information, inconsistencies, and compliance risks. It prevents common mistakes that cause HMRC or Companies House rejections, saving you time and helping you avoid penalties.",
    },
    {
      title: 'Unified Dashboard & Smart Tools',
      description:
        'See your entire compliance journey in one place. The dashboard gives you instant access to all filings, deadlines, receipts, iXBRL files, status updates, and downloadable reports. Built-in reminders help you stay ahead of upcoming due dates, making compliance simple and stress-free.',
    },
    {
      title: 'Secure UK-Based Data Protection',
      description:
        'Your security is our priority. BritFiler uses bank-level encryption, multi-layer authentication, and secure UK-based servers to protect your data. We are fully GDPR compliant, ensuring your financial and personal information remains safe at every stage of the filing process.',
    },
    {
      title: 'Optional Accountant Review & Support',
      description:
        'For users who want extra confidence, BritFiler offers optional review services from qualified accountants. Before submission, an expert checks your entries for accuracy, completeness, and compliance — giving you the reassurance of professional oversight at a fraction of traditional accounting costs.',
    },
  ]

  return (
    <div className='min-h-screen bg-white'>
      <NavHeader activeTab='features' />

      {/* Hero Section */}
      <div className='mx-auto px-4 sm:px-6 lg:px-20 py-12 md:py-16 w-full'>
        <div className='flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8 lg:gap-12 w-full'>
          <h1 className='text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 flex-1 text-start'>
            Features Of BritFiler
          </h1>
          <div className='flex flex-col items-start justify-center gap-4 flex-1'>
            <p className='text-lg md:text-xl text-gray-600 leading-relaxed text-start'>
              BritFiler combines modern design, automation, and compliance checks to make your tax and company filings simple, accurate, and stress-free. Whether you're a small business owner, freelancer, or accountant managing multiple clients — our tools are built to save you time and eliminate errors.
            </p>
            <button
              onClick={() => navigate('/sign-up')}
              className='bg-[#0A2540] hover:bg-[#0A2540]/90 text-white px-8 py-3 rounded-lg shadow-lg text-base font-medium transition-colors cursor-pointer'
            >
              Get Started
            </button>
          </div>
        </div>
      </div>

      {/* Features Grid */}
      <div className='mx-auto px-4 sm:px-6 lg:px-20 pb-12 md:pb-16'>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
          {features.map((feature, index) => (
            <div
              key={index}
              className='bg-gray-100 rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow'
            >
              <h2 className='text-xl md:text-2xl font-bold text-gray-900 mb-4 text-start'>
                {feature.title}
              </h2>
              <p className='text-gray-600 leading-relaxed text-sm md:text-base text-start'>
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  )
}
